import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { contactInfo } from "../mock/mock";

const Footer = () => {
  const { t } = useLang();

  const links = [
    { to: "/chi-siamo", label: t("nav.about") },
    { to: "/interdanza", label: t("nav.interdanza") },
    { to: "/arte-e-natura", label: t("nav.arteNatura") },
    { to: "/archivio", label: t("nav.archive") },
    { to: "/gallery", label: t("nav.gallery") },
    { to: "/contatti", label: t("nav.contact") },
  ];

  return (
    <footer className="bg-[#1c1b1a] text-[#d8d2c7]">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <img
            src="/arts4all-logo-tight.png"
            alt="arts4all"
            className="h-20 w-auto invert"
          />
          <p className="mt-4 text-sm leading-relaxed text-[#a49d90] max-w-xs">
            {t("footer.about")}
          </p>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-[#7c766b]">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#e08a5f] mb-5">
            {t("footer.quickLinks")}
          </h4>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-sm text-[#c7c0b4] hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#e08a5f] mb-5">
            {t("nav.contact")}
          </h4>
          <ul className="space-y-3 text-sm text-[#c7c0b4]">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-[#7c766b] shrink-0" />
              <span>via Puini, Livorno<br />57128, LI — Italia</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-[#7c766b] shrink-0" />
              <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors break-all">
                {contactInfo.email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#7c766b] shrink-0" />
              <a href={`tel:${contactInfo.phone}`} className="hover:text-white transition-colors">
                {contactInfo.phone}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-[#e08a5f] mb-5">
            {t("footer.followUs")}
          </h4>
          <div className="flex gap-3">
            <a
              href={contactInfo.instagram}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#3a3733] flex items-center justify-center hover:bg-[#e08a5f] hover:border-[#e08a5f] hover:text-[#1c1b1a] transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={contactInfo.facebook}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-[#3a3733] flex items-center justify-center hover:bg-[#e08a5f] hover:border-[#e08a5f] hover:text-[#1c1b1a] transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#2a2723]">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#7c766b]">
          <span>© {new Date().getFullYear()} arts4all — {t("footer.rights")}</span>
          <div className="flex items-center gap-4">
            <span>C.F. / P.IVA {contactInfo.vat}</span>
            <Link to="/cookie-policy" className="hover:text-[#e08a5f] transition-colors">
              Privacy & Cookie Policy
            </Link>
            <Link to="/admin" className="hover:text-[#e08a5f] transition-colors">
              Area riservata
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
